export default "__VITE_ASSET__De3_uXlL__"